import { render, staticRenderFns } from "./store-image.vue?vue&type=template&id=18cf6b26&scoped=true"
import script from "./store-image.vue?vue&type=script&lang=js"
export * from "./store-image.vue?vue&type=script&lang=js"
import style0 from "./store-image.vue?vue&type=style&index=0&id=18cf6b26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cf6b26",
  null
  
)

export default component.exports